import { useEffect } from 'react';
import { useObservable } from './useObservable';
import { sessionQuery, entryCodesQuery, entryCodesService } from '@lib/state';

export interface UserKeyOptions {
  withStays: boolean;
}

export function useUserKey(
  options: UserKeyOptions = {
    withStays: false,
  }
) {
  const user = useObservable(sessionQuery.currentUser);
  const keys = useObservable(entryCodesQuery.keys);
  const entryCodeData = useObservable(entryCodesQuery.entryCodeData);

  useEffect(() => {
    if (options.withStays) {
      entryCodesService.getEntryCodes();
    }
  }, []);

  return !user
    ? null
    : JSON.stringify({
        user: user['key'],
        keys,
        ...entryCodeData,
      });
}
